import { Injectable, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { Constants, Mode } from '../constants';
import { Router } from '@angular/router';
import { IUploadFile } from '../models';
import { ConfirmationComponent } from '../components';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class SharedService {
    ReportUserIdle = new Subject<any>();
    public mode: Mode;
    public loginUsername: string;
    public importAccess: any;
    public allowedAccess: string;
    constructor(private toastr: ToastrService, private http: HttpClient, public router: Router, private modalService: NgbModal) {
        this.importAccess = Constants.appConfig["importAccess"];
    }

    showErrorMessage(message: string) {
        this.toastr.error(message, 'Error', {
            timeOut: 5000
        });
    }

    showSuccessMessage(message: string) {
        this.toastr.success(message, 'Success', {
            timeOut: 5000
        });
    }

    clearSession() {
        sessionStorage.clear();
    }

    getOutLooks(days: number) {
        let outLooks = [];
        if (days) {
            for (let index = 0; index < days; index++) {
                outLooks.push({ 'code': index, 'description': 'Current Date +' + index + ' Day Out' })
            }
        }
        return outLooks;
    }

    logout() {
        this.clearSession();
        this.router.navigate(['/login']);
    }

    accessList() {
        return this.allowedAccess ? this.allowedAccess.split(',').filter(x => x.length != 0) : [];
    }

    isHavingAccess(route): boolean {
        const routes = this.accessList().map(x => x.toLowerCase());
        return routes.indexOf(route[0].path) > -1;
    }

    // showConfirmationPopUp(data: IUploadFile, moduleName: string) {
    //     const modalRef = this.modalService.open(ConfirmationComponent, { size: 'lg', windowClass: 'custom-addClass-modal', backdropClass: 'light-white-backdrop' });
    //     modalRef.componentInstance.selectedData = {
    //         OrganizationCode: data.OrganizationCode,
    //         TemplateEventId: data.TemplateEventId,
    //         NotificationEmail: data.NotificationEmail,
    //         FileData: data.FileData
    //     },
    //         modalRef.componentInstance.moduleName = moduleName;
    //     // modalRef.componentInstance.uploadFile = this.uploadFile;
    // }

    // uploadFile(data, moduleName: string) {
    //     debugger
    //     const options = {
    //         headers: new HttpHeaders({
    //             document: 'document'
    //         })
    //     };

    //     let formData: FormData = new FormData();
    //     formData.append('file', data.FileData as File, data.FileData.name);
    //     formData.append('eventId', data.TemplateEventId.toString());
    //     formData.append('orgCode', data.OrganizationCode);
    //     formData.append('emailId', data.NotificationEmail);
    //     formData.append('moduleName', moduleName);
    //     const url = `${Constants.apiEndPoints.upload.replace('moduleName', moduleName)}`
    //     return this.http
    //         .post(`${Constants.baseUrl}${url}`, data, options);
    // }

    //
}
